import { call, put, select, takeEvery } from "redux-saga/effects";
import { accessTokenSelector } from "../../auth/selectors/token";
import MetricsService from "../services/Metrics.service";
import {
  FETCH_METRIC_REQUEST,
  fetchMetricSuccess,
  fetchMetricFailure,
} from "../actions/metrics";

export function buildFiltersKey(filters) {
  if (!filters) return "";
  return Object.keys(filters)
    .sort()
    .map((k) => `${k}=${JSON.stringify(filters[k])}`)
    .join("&");
}

export function* fetchMetricSaga(action) {
  const { name, filters } = action.payload;
  const filtersKey = buildFiltersKey(filters);
  try {
    const service = new MetricsService();
    const token = yield select(accessTokenSelector);
    const data = yield call([service, service.getMetric], { name, filters, token });
    yield put(fetchMetricSuccess({ name, filtersKey, data }));
  } catch (error) {
    yield put(fetchMetricFailure({ name, error }));
  }
}

export default function* watchMetric() {
  yield takeEvery(FETCH_METRIC_REQUEST, fetchMetricSaga);
}
